;(function () {
  const initProductAccordion = () => {
    $('.about__accordion-toggle').click(function () {
      if (!$(this).hasClass('active')) {
        $(this).addClass('active')
        $(this).siblings('.about__accordion-description').eq($(this).index()).stop().slideDown(300)
      } else {
        $(this).removeClass('active')
        $(this).siblings('.about__accordion-description').stop().slideUp(300)
      }
    })
  }

  const initZoomImage = () => {
    const imagesWrapper = document.querySelector('.product-media-modal__content')
    const images = imagesWrapper.querySelectorAll('.js-image-zoom')

    images.forEach((el) => {
      el.addEventListener('click', (e) => {
        imagesWrapper.classList.toggle('zoom')
      })
    })
  }

  let revealPopupScrollHandler = null

  const initRevealPopup = () => {
    const stickyBar = document.querySelector('.product__popup') // Sticky bar
    const secondSection = document.querySelector('.product-section + section') // Second section

    // Remove previous handler if it exists to avoid duplicates on re-init.
    if (revealPopupScrollHandler) {
      window.removeEventListener('scroll', revealPopupScrollHandler)
      revealPopupScrollHandler = null
    }

    // Exit quietly when the elements are not on the page (e.g. other templates).
    if (!stickyBar || !secondSection) {
      return
    }

    const getOffset = (element) => {
      const rect = element.getBoundingClientRect()
      return rect.top + window.scrollY
    }

    revealPopupScrollHandler = () => {
      const secondSectionOffset = getOffset(secondSection)
      const isActive = window.scrollY > secondSectionOffset

      stickyBar.classList[isActive ? 'add' : 'remove']('active')
    }

    window.addEventListener('scroll', revealPopupScrollHandler, { passive: true })

    // Initial check in case the user starts in the middle of the page
    revealPopupScrollHandler()
  }

  const stickyAtcInstances = new WeakMap()

  const initStickyAtc = (scope = document) => {
    const stickyBar = scope.querySelector('[data-sticky-atc]')
    if (!stickyBar) {
      return
    }

    const sectionId = stickyBar.getAttribute('data-section-id')
    let sentinel = null
    if (sectionId) {
      const productInfo = document.getElementById(`ProductInfo-${sectionId}`)
      if (productInfo) {
        sentinel = productInfo.querySelector(`.sticky-button-sentinel[data-sticky-atc-sentinel="${sectionId}"]`)
      }
    }

    if (!sentinel) {
      sentinel = stickyBar.previousElementSibling
      if (!sentinel || !sentinel.classList || !sentinel.classList.contains('sticky-button-sentinel')) {
        sentinel = null
      }
    }

    if (!sentinel) {
      return
    }

    if (stickyAtcInstances.has(stickyBar)) {
      return
    }

    let productForm = null
    if (sectionId) {
      const productInfo = document.getElementById(`ProductInfo-${sectionId}`)
      if (productInfo) {
        productForm = productInfo.querySelector("form[data-type='add-to-cart-form']")
      }
    }

    if (!productForm) {
      productForm = document.querySelector("form[data-type='add-to-cart-form']")
    }

    if (!productForm) {
      return
    }

    // Detect if option is selected in local storage
    let optionsSelected = false

    const submitButton = productForm.querySelector('[type="submit"]')
    const stickyButton = stickyBar.querySelector('[data-sticky-atc-button]')
    const stickyLabel = stickyBar.querySelector('[data-sticky-atc-label]')

    if (!submitButton || !stickyButton || !stickyLabel) {
      return
    }

    const getButtonText = () => {
      const label = submitButton.querySelector('.card__quickview-text')
      if (label) {
        return label.textContent.trim()
      }
      return submitButton.textContent.trim()
    }

    const updateButtonState = () => {
      const disabled =
        submitButton.disabled ||
        submitButton.getAttribute('aria-disabled') === 'true' ||
        submitButton.classList.contains('loading')

      stickyButton.disabled = disabled
      stickyButton.setAttribute('aria-disabled', disabled.toString())
      stickyBar.classList.toggle('is-disabled', disabled)

      const text = !optionsSelected && !disabled ? 'Choose your size' : getButtonText()
      if (text) {
        stickyLabel.textContent = text
      }
    }

    const updateStickyButtonState = () => {
      optionsSelected = localStorage.getItem('selected_options') ? true : false
      updateButtonState()
    }

    const handleClick = () => {
      const disabled =
        submitButton.disabled ||
        submitButton.getAttribute('aria-disabled') === 'true' ||
        submitButton.classList.contains('loading')

      // Find the product options section (color/size selection)
      // Try multiple selectors to find the variant options
      let productOptions = document.querySelector('variant-radios')

      if (!productOptions) {
        productOptions = document.querySelector('variant-selects')
      }

      if (!productOptions) {
        productOptions = document.querySelector('.product-parameters')
      }

      if (!productOptions) {
        productOptions = document.querySelector('.product-form__controls')
      }

      // Always scroll to options - whether or not button is disabled
      if (productOptions) {
        // Scroll to the options section with smooth behavior
        productOptions.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        })

        // Optional: Add a brief highlight effect to draw attention
        productOptions.style.transition = 'background-color 0.3s ease'
        const originalBg = window.getComputedStyle(productOptions).backgroundColor
        productOptions.style.backgroundColor = 'rgba(var(--color-button), 0.1)'
        setTimeout(() => {
          productOptions.style.backgroundColor = originalBg
        }, 600)
      }

      // If options are selected and button is not disabled, add to cart
      if (optionsSelected && !disabled) {
        submitButton.click()
      }
    }

    stickyButton.addEventListener('click', handleClick)

    updateButtonState()

    const mutationObserver = new MutationObserver(updateButtonState)
    mutationObserver.observe(submitButton, {
      attributes: true,
      childList: true,
      subtree: true
    })

    const shouldShowSticky = (entry) => {
      if (!entry) {
        return false
      }

      const { isIntersecting, boundingClientRect } = entry
      return !isIntersecting && boundingClientRect.top < 0
    }

    const stickyObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          updateStickyButtonState()
          stickyBar.classList.toggle('is-visible', shouldShowSticky(entry))
        })
      },
      { threshold: 0 }
    )

    stickyObserver.observe(sentinel)

    const initialRect = sentinel.getBoundingClientRect()
    const initialIntersecting = initialRect.bottom > 0 && initialRect.top < window.innerHeight
    const initialVisibility = !initialIntersecting && initialRect.top < 0
    stickyBar.classList.toggle('is-visible', initialVisibility)

    stickyAtcInstances.set(stickyBar, {
      handleClick,
      stickyButton,
      mutationObserver,
      stickyObserver
    })
  }

  const mobileBreakpoint = window.matchMedia('(max-width: 749px)')
  const buyButtonPositions = new WeakMap()

  const moveBuyButtonsForMobile = (scope = document) => {
    const containers = scope.querySelectorAll('.product__info-main_content')

    if (!containers.length) {
      return
    }

    containers.forEach((container) => {
      const buyButtons = container.querySelector('.product__buy_buttons')
      const priceWrapper = container.querySelector('.price-wrapper')
      const installmentWrapper = container.querySelector('.installment-wrapper')

      if (!buyButtons || !priceWrapper) {
        return
      }

      if (!buyButtonPositions.has(buyButtons)) {
        buyButtonPositions.set(buyButtons, {
          parent: buyButtons.parentNode,
          nextSibling: buyButtons.nextSibling
        })
      }

      if (mobileBreakpoint.matches) {
        if (buyButtons.dataset.mobileMoved === 'true') {
          return
        }

        const target = installmentWrapper && container.contains(installmentWrapper) ? installmentWrapper : priceWrapper

        target.insertAdjacentElement('afterend', buyButtons)
        buyButtons.dataset.mobileMoved = 'true'
      } else if (buyButtons.dataset.mobileMoved === 'true') {
        const originalPosition = buyButtonPositions.get(buyButtons)

        if (!originalPosition || !originalPosition.parent) {
          return
        }

        if (originalPosition.nextSibling && originalPosition.nextSibling.parentNode === originalPosition.parent) {
          originalPosition.parent.insertBefore(buyButtons, originalPosition.nextSibling)
        } else {
          originalPosition.parent.appendChild(buyButtons)
        }

        delete buyButtons.dataset.mobileMoved
      }
    })
  }

  const handleBreakpointChange = () => moveBuyButtonsForMobile()

  if (mobileBreakpoint.addEventListener) {
    mobileBreakpoint.addEventListener('change', handleBreakpointChange)
  } else if (mobileBreakpoint.addListener) {
    mobileBreakpoint.addListener(handleBreakpointChange)
  }

  const initCompareFitSync = () => {
    // Find all "Compare Fit" radio inputs and sync with the selected value display
    const compareFitInputs = document.querySelectorAll('input[name="Compare Fit"]')

    if (compareFitInputs.length === 0) {
      return
    }

    compareFitInputs.forEach((input) => {
      input.addEventListener('change', function () {
        if (this.checked) {
          // Find the corresponding selected value display span
          const fieldset = this.closest('fieldset.product-form__controls')
          if (fieldset) {
            const selectedValueSpan = fieldset.querySelector('.product-form__selected-value')
            if (selectedValueSpan) {
              // Format the value (capitalize each word)
              const value = this.value
              const words = value.toLowerCase().split(' ')
              const formatted = words.map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
              selectedValueSpan.textContent = formatted
            }
          }
        }
      })
    })
  }

  const initCompareFitModal = () => {
    const modal = document.querySelector('.compare-fit-modal')
    if (!modal) return

    // Handle clicking the Compare Fit label to open modal
    const compareFitLabel = document.querySelector('.product-options-label--clickable')
    if (compareFitLabel) {
      compareFitLabel.addEventListener('click', function (e) {
        e.preventDefault()
        const modalId = this.getAttribute('data-modal')
        const targetModal = document.querySelector(modalId)
        if (targetModal && targetModal.show) {
          targetModal.show(this)
        }
      })
    }

    // Watch for modal open/close
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'open') {
          if (modal.hasAttribute('open')) {
            document.body.classList.add('compare-fit-modal-open')
          } else {
            document.body.classList.remove('compare-fit-modal-open')
          }
        }
      })
    })

    observer.observe(modal, { attributes: true })
  }

  document.addEventListener('shopify:section:load', function (event) {
    const scope = event && event.target ? event.target : document
    initProductAccordion()
    initZoomImage()
    initRevealPopup()
    initStickyAtc(scope)
    moveBuyButtonsForMobile(scope)
    setTimeout(initCompareFitSync, 100)
    setTimeout(initCompareFitModal, 100)
  })

  initProductAccordion()
  initZoomImage()
  initRevealPopup()
  initStickyAtc()
  moveBuyButtonsForMobile()

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-sticky-atc]').forEach((stickyBar) => {
      const instance = stickyAtcInstances.get(stickyBar)
      if (!instance) {
        return
      }

      if (instance.mutationObserver) {
        instance.mutationObserver.disconnect()
      }

      if (instance.stickyObserver) {
        instance.stickyObserver.disconnect()
      }

      if (instance.stickyButton && instance.handleClick) {
        instance.stickyButton.removeEventListener('click', instance.handleClick)
      }

      stickyAtcInstances.delete(stickyBar)
    })
  })

  // Wait for DOM to be fully loaded before initializing compare fit sync
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initCompareFitSync()
      initCompareFitModal()
    })
  } else {
    setTimeout(initCompareFitSync, 100)
    setTimeout(initCompareFitModal, 100)
  }
})()

class FloatedForm extends HTMLElement {
  constructor() {
    super()
    this.renderForm()
  }

  renderForm() {
    fetch(this.getAttribute('data-product-url'))
      .then((response) => response.text())
      .then((responseText) => {
        const responseHTML = new DOMParser().parseFromString(responseText, 'text/html')
        this.productElement = responseHTML.querySelector('div[id^="ProductInfo-"]')

        this.preventDuplicatedIDs()
        this.removeDOMElements()
        this.setInnerHTML(this, this.productElement.innerHTML)

        if (window.Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init()
        }

        if (window.ProductModel) window.ProductModel.loadShopifyXR()

        this.showMoreFields()
      })
      .finally(() => {
        const selectDropDown = () => {
          $('.product__popup .product-form__controls--dropdown').each(function () {
            const elListItem = $(this).find('.dropdown-select ul li')
            const elItem = $(this).find('.dropdown-select ul')
            const selectedText = $(this).find('.dropdown-select .select-label')

            selectedText.on('click', function (e) {
              elItem.toggleClass('active')
              if (elItem.hasClass('active')) {
                e.stopPropagation()
                $(document).click(function () {
                  elItem.removeClass('active')
                })
              }
            })

            elListItem.on('click', function () {
              selectedText.find('span').text($(this).text()).attr('title', $(this).text())
              elItem.removeClass('active')
              document.activeElement.blur()
            })
          })
        }

        selectDropDown()
      })
  }

  setInnerHTML(element, html) {
    element.innerHTML = html

    // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script')
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value)
      })
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML))
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag)
    })
  }

  preventDuplicatedIDs() {
    const sectionId = this.productElement.dataset.section
    this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `floated-${sectionId}`)

    if (this.productElement.querySelectorAll('variant-selects')) {
      this.productElement.querySelectorAll('variant-selects').forEach((radio) => {
        radio.dataset.originalSection = sectionId
      })
    }

    if (this.productElement.querySelectorAll('variant-radios')) {
      this.productElement.querySelectorAll('variant-radios').forEach((radio) => {
        radio.dataset.originalSection = sectionId
      })
    }
  }

  removeDOMElements() {
    const text = this.productElement.querySelector('.product__text')
    if (text) text.remove()

    const tags = this.productElement.querySelector('.product__tags')
    if (tags) tags.remove()

    const title = this.productElement.querySelector('.product__title__wrapper')
    if (title) title.remove()

    const badges = this.productElement.querySelector('.product__custom-badges')
    if (badges) badges.remove()

    const price = this.productElement.querySelector('.price-wrapper')
    if (price) price.remove()

    const description = this.productElement.querySelector('.product__description')
    if (description) description.remove()

    const sku = this.productElement.querySelector('.product__sku')
    if (sku) sku.remove()

    const inventory = this.productElement.querySelector('.product__inventory')
    if (inventory) inventory.remove()

    const pickupAvailability = this.productElement.querySelector('pickup-availability')
    if (pickupAvailability) pickupAvailability.remove()

    const customLiquid = this.productElement.querySelector('.custom-liquid')
    if (customLiquid) customLiquid.remove()

    const complementary = this.productElement.querySelector('product-recommendations')
    if (complementary) complementary.remove()

    const shareButtons = this.productElement.querySelector('.share-buttons')
    if (shareButtons) shareButtons.remove()

    const productModal = this.productElement.querySelectorAll('.product-popup')
    productModal.forEach((advantage) => {
      advantage.remove()
    })

    const productForm = this.productElement.querySelector('floated-form')
    if (productForm) productForm.remove()
  }

  showMoreFields() {
    $('.js-show-more').click(function (e) {
      e.preventDefault()
      $(this).siblings('input').removeClass('hidden')
      $(this).siblings('label').removeClass('hidden')
      $(this).remove()
    })
  }
}

customElements.define('floated-form', FloatedForm)
